import { render, staticRenderFns } from "./ScreenDevolucionNormal.vue?vue&type=template&id=51b118fc"
import script from "./ScreenDevolucionNormal.vue?vue&type=script&lang=js"
export * from "./ScreenDevolucionNormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports